import { render, staticRenderFns } from "./Carousel2.vue?vue&type=template&id=0bb7532a&scoped=true"
import script from "./Carousel2.vue?vue&type=script&lang=js"
export * from "./Carousel2.vue?vue&type=script&lang=js"
import style0 from "./Carousel2.vue?vue&type=style&index=0&id=0bb7532a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb7532a",
  null
  
)

export default component.exports